import { Button, Card, CardContent, Input } from '@estac1/ui';
import type { UseMutationResult } from '@tanstack/react-query';
import type { AlprSample } from './types.js';

interface AlprReviewCardProps {
  current: AlprSample;
  index: number;
  total: number;
  correction: string;
  onCorrectionChange: (v: string) => void;
  review: Pick<
    UseMutationResult<
      unknown,
      Error,
      { confirm?: boolean; reject?: boolean; actualPlate?: string }
    >,
    'isPending' | 'mutate'
  >;
  onSkip: () => void;
}

export const AlprReviewCard = ({
  current,
  index,
  total,
  correction,
  onCorrectionChange,
  review,
  onSkip,
}: AlprReviewCardProps) => (
  <Card>
    <CardContent className="space-y-4 pt-6">
      <div className="flex flex-col gap-1 text-xs text-muted-fg sm:flex-row sm:items-center sm:justify-between">
        <span>
          {index + 1} / {total}
        </span>
        <span className="break-words">
          conf {current.confidenceScore ?? '—'} · {current.plateFormat ?? '—'} ·{' '}
          {current.lighting ?? '—'} · {new Date(current.createdAt).toLocaleString('pt-BR')}
        </span>
      </div>
      {current.imageUrl ? (
        <img
          src={current.imageUrl}
          alt="Placa"
          className="mx-auto max-h-64 rounded border border-border object-contain"
        />
      ) : (
        <p className="text-center text-sm text-muted-fg">Sem URL de imagem (R2/presign).</p>
      )}
      <div className="space-y-1">
        <p className="text-xs font-medium uppercase tracking-wider text-muted-fg">Predição</p>
        <p className="font-mono text-2xl font-bold tracking-widest">
          {current.predictedPlate || '—'}
        </p>
      </div>
      <div className="space-y-1">
        <label className="text-xs font-medium text-muted-fg" htmlFor="alpr-actual">
          Placa correta
        </label>
        <Input
          id="alpr-actual"
          className="font-mono text-lg tracking-widest uppercase"
          value={correction}
          onChange={(e) => onCorrectionChange(e.target.value.toUpperCase())}
          maxLength={8}
        />
      </div>
      <div className="flex flex-col gap-2 sm:flex-row sm:flex-wrap">
        <Button
          className="w-full sm:w-auto"
          disabled={review.isPending}
          onClick={() => review.mutate({ confirm: true })}
        >
          Confirmar (Enter)
        </Button>
        <Button
          variant="outline"
          className="w-full sm:w-auto"
          disabled={review.isPending || correction.trim().length < 7}
          onClick={() => review.mutate({ actualPlate: correction.trim() })}
        >
          Salvar correção
        </Button>
        <Button
          variant="ghost"
          className="w-full sm:w-auto"
          disabled={review.isPending}
          onClick={() => review.mutate({ reject: true })}
        >
          Rejeitar
        </Button>
        <Button
          variant="ghost"
          className="w-full sm:w-auto"
          disabled={index >= total - 1}
          onClick={onSkip}
        >
          Pular
        </Button>
      </div>
    </CardContent>
  </Card>
);
